// Utility to convert UTC or local date string to formatted local datetime string
export function formatToLocalDateTime(dateString: string): string {
  if (!dateString) return '';
  // Ensure UTC if missing timezone info
  const date = dateString.endsWith('Z') ? new Date(dateString) : new Date(dateString + 'Z');
  return date.toLocaleString();
}
